import React from "react";
import "./table.scss";
import { PropTypes } from "prop-types";
export const TableCompare = ({
  data,
  hideSeats,
  isSenate,
  isCouncilor,
  showPerson,
  details,
  legend
}) => {
  return React.createElement("div", {
    className: "table-datosContainer"
  }, React.createElement("div", {
    className: "table-datosScroll"
  }, React.createElement("div", {
    className: "table-wrapper"
  }, data.length !== 0 && React.createElement("table", {
    summary: isSenate ? "Senadores por partido" : "Escaños por partido."
  }, React.createElement("thead", null, React.createElement("tr", null, React.createElement("th", {
    className: "partido"
  }, !showPerson ? "Partido" : "Representante"), !hideSeats && React.createElement("th", {
    className: "escanos"
  }, isSenate ? "Senadores" : isCouncilor ? "Concejales" : "Escaños"), details && React.createElement("th", {
    className: "porcentaje"
  }, "%"), details && React.createElement("th", {
    className: "votos"
  }, "Votos"))), React.createElement("tbody", null, data.filter(item => {
    return item.seats > 0 || details && item.votes > 0;
  }) // TODO REVISAR
  .map(item => React.createElement("tr", {
    key: item.name || item.partyAcronym || item.id
  }, React.createElement("td", {
    className: "dato-nombre-partido"
  }, React.createElement("span", {
    style: {
      borderLeft: "5px solid ".concat(item.partyColor)
    }
  }, React.createElement("span", {
    className: "partido"
  }, !showPerson ? item.partyAcronym : "".concat(item.name, " (").concat(item.partyAcronym, ")")))), !hideSeats && React.createElement("td", {
    className: "dato-escanos"
  }, item.seats), details && React.createElement("td", {
    className: "dato-escanos"
  }, Number(item.votesPercent).toLocaleString("es")), details && React.createElement("td", {
    className: "dato-escanos_votes"
  }, Number(item.votes).toLocaleString("de")))))))), React.createElement("div", {
    className: "legendContainer"
  }, legend && legend.map(legendItem => React.createElement("p", {
    key: legendItem,
    className: "table-datosLegend"
  }, legendItem))));
};
TableCompare.propTypes = {
  // eslint-disable-next-line
  data: PropTypes.array.isRequired,
  hideSeats: PropTypes.bool,
  isSenate: PropTypes.bool,
  isCouncilor: PropTypes.bool
};
TableCompare.defaultProps = {
  hideSeats: false,
  isSenate: false,
  isCouncilor: false,
  legend: undefined
};
export default TableCompare;